import { combineReducers } from 'redux';

import loadingReducer from 'modules/global/reducers/generic.loading';
import * as types from 'modules/medias/actionTypes';
import idsToDelete from 'modules/medias/reducer/data/idsToDelete';

import clippedReducer from './clipped';

/**
 * @typedef {{
 *   idsToDelete: string[],
 *   clipped: Record<string, boolean>,
 *   isPatching: boolean,
 *   isDeleting: boolean,
 *   isUploading: boolean,
 *   isPersisting: boolean,
 * }} MediasUIReducer
 */

export default combineReducers({
  idsToDelete,
  clipped: clippedReducer,
  isPatching: loadingReducer(types.PATCH_MEDIA),
  isDeleting: loadingReducer(types.DELETE_MEDIA),
  isUploading: loadingReducer(types.UPLOAD_MEDIAS),
  isPersisting: loadingReducer(types.PERSIST_ITEMS_TO_ENTITY)
});
